import { useState } from 'react'
import { LoginCallback as OktaLoginCallback } from '@okta/okta-react'
import { isJumpCloudSignInCallback } from 'oidc/jumpcloud'
import JumpCloudLoginCallback from './JumpCloudLoginCallback'

function LoginCallback() {
  // Decided once on mount: handling JumpCloud's callback removes the saved sign-in it is detected by.
  const [isJumpCloudSignIn] = useState(isJumpCloudSignInCallback)

  return isJumpCloudSignIn ? <JumpCloudLoginCallback /> : <OktaLoginCallback />
}

export default LoginCallback
